import React from "react";
import Footer from "./shared/Footer";

import ObersurfaceImage from "../images/about-obersurfaces.jpg";
import Paris55Image from "../images/about-55-paris.jpg";
import ObersurfaceLogo from "../images/brands/obersurfaces.svg";
import Paris55Logo from "../images/logos/logo-5-5-paris.svg";



const About = props => (
  <React.Fragment>
    <section className="pv7 bb tc" style={{ marginTop: "56px" }}>
      <div className="f3">
          {props.t("pageDescription1")}<br/>
          {props.t("pageDescription2")}<br/>
          {props.t("pageDescription3")}
      </div>
    </section>

    <section className="grid grid--2">
      <div className="grid__item">
        <div
          className="about__picture"
          style={{ backgroundImage: `url(${ObersurfaceImage})` }}
        />
        <div className="about__text">
          <div className="about__logo about__logo--obersurfaces">
            <img src={ObersurfaceLogo} alt="OberSurfaces" />
          </div>
          <p>{props.t("obersurfacesDescription1")}</p>
          <p>{props.t("obersurfacesDescription2")}</p>
          <p>{props.t("obersurfacesDescription3")}</p>
          <div className="pt6 tc">
            <a
              className="button"
              href="http://www.ober-surfaces.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.ober-surfaces.com
            </a>
          </div>
        </div>
      </div>
      <div className="grid__item">
        <div
          className="about__picture"
          style={{ backgroundImage: `url(${Paris55Image})` }}
        />
        <div className="about__text">
          <div className="about__logo about__logo--55-paris">
            <img src={Paris55Logo} alt="5-5" />
          </div>
          <p>{props.t("studio55Description1")}</p>
          <p>{props.t("studio55Description2")}</p>

          <div className="pt6 tc">
            <a
              className="button"
              href="http://www.5-5.paris/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.5-5.paris
            </a>
          </div>
        </div>
      </div>
    </section>
    <Footer t={props.t} />
  </React.Fragment>
);


export default About;



// WEBPACK FOOTER //
// ./src/components/About.js